import React from 'react';

import MediaServicesActualSizeIcon from '@atlaskit/icon/glyph/media-services/actual-size';
import MediaServicesFitToPageIcon from '@atlaskit/icon/glyph/media-services/fit-to-page';

import {
  LoadingButtonWithTooltip,
  LoadingButtonWithTooltipProps,
} from '@qality/common-components/src/molecules/LoadingButtonWithTooltip';
import { FEATURE_FLAG } from '@qality/common-config';

type FullscreenButtonProps = {
  isFullscreenMode: boolean;
  onOpen: () => void;
  onClose: () => void;
};

export default function FullscreenButton({
  isFullscreenMode,
  onOpen,
  onClose,
}: FullscreenButtonProps): JSX.Element {
  const getButtonProps = (): Pick<
    LoadingButtonWithTooltipProps['loadingButtonProps'],
    'iconBefore' | 'onClick'
  > => {
    if (isFullscreenMode) {
      return {
        iconBefore: (
          <MediaServicesFitToPageIcon label='Open full-screen view' />
        ),
        onClick: onClose,
      };
    }

    return {
      iconBefore: (
        <MediaServicesActualSizeIcon label='Close full-screen view' />
      ),
      onClick: onOpen,
    };
  };

  return (
    <LoadingButtonWithTooltip
      loadingButtonProps={{
        ...getButtonProps(),
        appearance: 'subtle',
        isDisabled: !FEATURE_FLAG.isPremium,
      }}
      tooltipProps={{
        content: !FEATURE_FLAG.isPremium
          ? 'Editing test case in full-screen available only in QAlity Plus.'
          : '',
      }}
    />
  );
}
